import { useRef, useState } from "react";

export const useListUsuario = () => {

    const refComponentToPrint = useRef<any>(null);
    const createStyledRetratoOuPaisagem = useRef<HTMLStyleElement | null>(null);

    const [loadingPage, setLoadingPage] = useState(false);

    return {
        loadingPage,
        setLoadingPage,
        refComponentToPrint,
        createStyledRetratoOuPaisagem,
    }
}
